import { mount_vue_app, read_app_config } from '../_partials/_app.js';
import App from './job-titles-app/app.vue';

(function () {
	const app_el = document.getElementById(`js-job-titles-app`);
	if (!app_el) {
		return;
	}

	const config = read_app_config(app_el);

	mount_vue_app(app_el, () => ({
		component: App,
		props: {
			api_url: config.api_url,
			items: config.items,
			defaults: config.defaults,
		},
		store: {
			api_url: config.api_url,
			logo_url_template: config.logo_url_template,
		},
	}));
})();
